import { render, staticRenderFns } from "./TransferCompanyWorkshopDialogCpt.vue?vue&type=template&id=5e91d3c5&"
import script from "./TransferCompanyWorkshopDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./TransferCompanyWorkshopDialogCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports